import { Directive, OnInit } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

@Directive({
    selector: 'ngx-smart-modal[disableRefocus]',
    standalone: false
})
export class DisableModalRefocusDirective implements OnInit {
    constructor(private modal: NgxSmartModalComponent) { }

    ngOnInit() {
        this.modal.refocus = false;
    }
} 